import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const OperationalReviewAction = ({ jobId, onPrepared }) => {
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const prepare = async () => {
    if (busy) return; setBusy(true); setError("");
    try { await api.post(`/reader/jobs/${jobId}/prepare-quote`); await onPrepared(); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return <section className="border-y py-4 space-y-3" data-testid="operational-prepare-action">
    <p className="text-sm" data-testid="operational-review-note">Dati della nuova lettura da verificare. Le informazioni mancanti resteranno evidenziate nel preventivo; nessuna approvazione automatica.</p>
    {error && <p role="alert" className="text-red-800 text-sm" data-testid="operational-prepare-error">{error}</p>}
    <Button data-testid="operational-prepare-quote" onClick={prepare} disabled={busy}>{busy ? "Preparazione…" : "Completa parametri e calcola"}</Button>
  </section>;
};